import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { putErrorNotification } from '../../../../../../../utils/saga';
import { normalize } from '../../../../../../../redux/normalizr';
import { deviationSchema } from '../../../../../../../redux/normalizr/schemas/deviation';
import { putEntities } from '../../../../../../../redux/entities/actions';
import { initialize, initializeSuccess, initializeError } from '../actions';
import type { PapiDaSharedDeviationSubmitInit } from '@wix/da-papi-types';

function* initializeSaga(action: ReturnType<typeof initialize>): SagaIterator {
  const {
    payload: { deviationId },
  } = action;

  const response: PapiDaSharedDeviationSubmitInit = yield call(requestPuppy, {
    method: 'get',
    url: '/deviation/submit/init',
    params: {
      deviationid: deviationId,
    },
  });

  if (!response || !response.deviation || isApiError(response)) {
    const errorMessage = 'Failed to initialize boost';
    yield putErrorNotification(errorMessage);
    yield put(initializeError(errorMessage));

    return;
  }

  // Normalize the deviation and put it in the global entities store
  const { entities } = normalize(response.deviation, deviationSchema);
  yield put(putEntities({ entities }));

  // Extract tags and recommendedTags for the boost modal
  const payload = {
    deviationId,
    tags: response.tags?.map(tag => tag.name) || [],
    recommendedTags: response.recommendedTags?.map(tag => tag.name) || [],
  };

  yield put(initializeSuccess(payload));
}

export default function* boostSaga() {
  yield takeEvery(initialize, initializeSaga);
}
